import { listExternalServices, createExternalService, deleteExternalService, updateExternalService, listAllExternalServices } from '../lib/db/external-services';

export class ExternalServicesAPI {
  static async listByUser(clerkId: string) {
    return await listExternalServices(clerkId);
  }

  static async listAll() {
    return await listAllExternalServices();
  }

  static async create(clerkId: string, data: {
    name: string;
    type?: string;
    domain?: string;
    price: number;
    payType: 'ANUAL' | 'MENSUAL';
    startDate: Date | string;
    nextPaymentDate?: Date | string;
  }) {
    // Helper to ensure Date object
    const toDate = (d: Date | string) => (typeof d === 'string' ? new Date(d) : d);

    return await createExternalService(clerkId, {
      ...data,
      payType: data.payType as any, // Type assertion to match enum
      startDate: toDate(data.startDate),
      nextPaymentDate: data.nextPaymentDate ? toDate(data.nextPaymentDate) : undefined
    });
  }

  static async update(id: string, data: {
    name?: string;
    type?: string;
    domain?: string;
    price?: number;
    payType?: 'ANUAL' | 'MENSUAL';
    startDate?: Date | string;
    nextPaymentDate?: Date | string;
    userId?: string;
  }) {
    const toDate = (d: Date | string) => (typeof d === 'string' ? new Date(d) : d);

    const updateData: any = { ...data };
    if (data.startDate) updateData.startDate = toDate(data.startDate);
    if (data.nextPaymentDate) updateData.nextPaymentDate = toDate(data.nextPaymentDate);
    
    return await updateExternalService(id, updateData);
  }

  static async delete(id: string) {
    return await deleteExternalService(id);
  }

  static async sendStatusEmail(data: {
    userEmail: string;
    userName: string;
    planName: string;
    planPrice: string;
    planCurrency: string;
    planPeriod: string;
    status?: string;
    renewalDate?: string;
    type: 'STATUS_CHANGE' | 'DELETED' | 'DATE_CHANGE';
  }): Promise<void> {
    fetch('/api/send-status-email', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    }).catch(err => console.error('Error sending status email:', err));
  }
}
